import React, { useEffect } from "react";
import { formatIDR } from "helpers/utils";
// import customInput from "../../../assets/scss/EmailSuiteOrder.module.scss"; // File sudah dihapus
import PromoKaosTumbler from "components/PromoKaosTumbler";
import { useSelector, useDispatch } from "react-redux";
import { changeProductFromCart } from "features/common/layouts/cartSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const EmailSuiteTitan = ({
  selectedProduct,
  selectedProductName,
  selectedPeriod,
  domain,
  setDomain,
  totalPrice,
  setTotalPrice,
  formValues,
  updateFormValues,
  configOptions,
  updateConfigOptions,
  customFields,
  updateCustomFields,
  handleProductChange,
  handlePeriodChange,
  handleAddToCart,
  product,
  validationManager,
  productManager,
}) => {
  const { productsList } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  // Get current product data
  const selectedProductData = product?.find(
    (data) => data.pid === parseInt(selectedProduct)
  );

  const selectedProductConfigOptions = selectedProductData
    ? selectedProductData.configoptions?.configoption || []
    : [];

  // Initialize config options and custom fields on component mount
  useEffect(() => {
    if (selectedProductData) {
      const newConfigOptions = {};
      const newCustomFields = {};

      // Extract config options
      selectedProductConfigOptions.forEach((config) => {
        newConfigOptions[config.name] = config.id;
      });

      // Extract custom fields
      if (selectedProductData.customfields?.customfield) {
        selectedProductData.customfields.customfield.forEach((field) => {
          newCustomFields[field.name] = field.id;
        });
      }

      updateConfigOptions(newConfigOptions);
      updateCustomFields(newCustomFields);

      // Set default values
      const defaultValues = {};
      selectedProductConfigOptions.forEach((config) => {
        config.options.option.forEach((option) => {
          // Use consistent naming for account fields
          if (config.name === "Jumlah Akun" || config.name === "Email Accounts") {
            defaultValues["Akun"] = 1; // Default to 1 account
          } else {
            defaultValues[config.name] = 1; // Default to 1 for other fields
          }
        });
      });

      updateFormValues(defaultValues);
    }
  }, [selectedProductData]);

  // Calculate price when form values change
  useEffect(() => {
    if (selectedProductData) {
      const newPrice = productManager.calculatePrice(
        selectedProductData,
        configOptions,
        selectedPeriod,
        formValues
      );
      setTotalPrice(newPrice);
    }
  }, [formValues, selectedPeriod, selectedProductData, configOptions]);

  const handleInputChange = (configName, value) => {
    const numValue = parseInt(value) || 0;
    updateFormValues({ [configName]: numValue });

    // Update cart if product is already in cart
    const existingCartItem = productsList.find(item => item.type === "emailSuite");
    if (existingCartItem && selectedProductData) {
      // Use productManager to build the complete payload
      const updatedFormValues = { ...formValues, [configName]: numValue };
      const productPayload = productManager.buildProductPayload(
        "titan",
        selectedProductData,
        {
          ...updatedFormValues,
          selectedPeriod: selectedPeriod
        },
        configOptions,
        customFields
      );

      if (productPayload) {
        dispatch(changeProductFromCart(productPayload));
      }
    }
  };

  const handleDomainChange = (e) => {
    setDomain(e.target.value);
  };

  // Get available periods based on product pricing
  const getAvailablePeriods = () => {
    if (!selectedProductData || !selectedProductData.configoptions?.configoption) {
      return [];
    }

    const allPeriods = [
      { value: "monthly", label: "1 bulan" },
      { value: "quarterly", label: "3 bulan" },
      { value: "semiannually", label: "6 bulan" },
      { value: "annually", label: "1 tahun" },
      { value: "biennially", label: "2 tahun" },
      { value: "triennially", label: "3 tahun" },
    ];

    // Check if any config option has valid pricing for each period
    const availablePeriods = allPeriods.filter(period => {
      return selectedProductConfigOptions.some(config => {
        return config.options.option.some(option => {
          const pricing = option.pricing?.IDR?.[period.value];
          return pricing && parseFloat(pricing) > 0;
        });
      });
    });

    return availablePeriods.length > 0 ? availablePeriods : allPeriods;
  };

  const periodOptions = getAvailablePeriods();

  if (!selectedProductData) {
    return <div>Loading product data...</div>;
  }

  return (
    <div className="mb-3">
      <h5 className="mb-3 fw-bold">Konfigurasi Titan Email</h5>

      {/* Product Selection */}
      <div className="mb-3">
        <label htmlFor="product" className="form-label fw-bold">
          Pilih Produk
        </label>
        <select
          className="form-select"
          id="product"
          value={selectedProduct}
          onChange={(e) => {
            const selectedProd = product?.find(p => p.pid === parseInt(e.target.value));
            handleProductChange(e.target.value, selectedProd?.name || "");
          }}
        >
          {product?.map((prod) => (
            <option key={prod.pid} value={prod.pid}>
              {prod.name}
              </option>
          ))}
        </select>
      </div>

      {/* Product Details */}
      <div className="mb-3">
        {selectedProductName === "Titan Email Pro" && (
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>10 GB Storage per Mailbox</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>3 Professional Email Templates</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>1 Contact Group</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>200 Emails per Hour, 500 Emails per Day</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Undo Send Feature Not Available</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Two-Factor Authentication Not Available</strong>
                </span>
              </div>
            </div>
          </div>
        )}
        {selectedProductName === "Titan Email Premium" && (
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>50 GB Storage per Mailbox</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Unlimited Email Templates</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Unlimited Contact Groups</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>300 Emails per Hour, 500 Emails per Day</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Undo Send Feature Available</strong>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                <span className="text-muted small">
                  <strong>Two-Factor Authentication Available</strong>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Period Selection and Configuration Options */}
      <div className="row g-3">
        <div className="col-12 col-md-6 mb-2">
          <label htmlFor="period" className="form-label fw-bold">
          Pilih Periode
        </label>
        <select
          className="form-select"
            id="period"
          value={selectedPeriod}
            onChange={(e) => handlePeriodChange(e.target.value)}
          >
            {periodOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      </div>

        {/* Configuration Options */}
      {selectedProductConfigOptions.map((config) =>
        config.options.option.map((option, i) => (
            <div key={i} className="col-12 col-md-6 mb-2">
              <label htmlFor={config.name} className="form-label fw-bold">
              {config.name}
            </label>
              <div className="input-group">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    const currentValue = formValues[config.name] || 1;
                    if (currentValue > 1) {
                      handleInputChange(config.name, currentValue - 1);
                    }
                  }}
                  disabled={(formValues[config.name] || 1) <= 1}
                >
                  -
                </button>
            <input
              type="number"
                  min="1"
                  className="form-control text-center"
                  id={config.name}
                  value={formValues[config.name] || 1}
                  onChange={(e) => handleInputChange(config.name, e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    const currentValue = formValues[config.name] || 1;
                    handleInputChange(config.name, currentValue + 1);
                  }}
                >
                  +
                </button>
              </div>
          </div>
        ))
      )}
      </div>

      {/* Domain Input */}
      <div className="mb-3">
        <label htmlFor="domain" className="form-label fw-bold">
          Domain (Wajib Diisi)
        </label>
        <input
          type="text"
          className="form-control"
          id="domain"
          placeholder="Contoh: example.com"
          value={domain}
          onChange={handleDomainChange}
        />
      </div>

      {/* Price Display */}
      <div className="row mb-3 align-items-center">
        <div className="col-6 col-md-4">
          <label className="form-label fw-bold mb-0">Total Harga</label>
        </div>
        <div className="col-6 col-md-8 text-end">
          <span className="fw-bold fs-5">{formatIDR(totalPrice)}</span>
        </div>
      </div>

      {/* Add to Cart Button */}
      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-cta fw-bold py-2 px-5 rounded-5"
          onClick={handleAddToCart}
        >
          Tambahkan Ke Keranjang
        </button>
      </div>

      {/* PromoKaosTumbler - Only show if product is in cart */}
      {productsList && productsList.some(item => item.type === "emailSuite") && (
        <div className="mt-4">
          <PromoKaosTumbler price={totalPrice} billingcycle={selectedPeriod} />
        </div>
      )}
    </div>
  );
};

export default EmailSuiteTitan;
